export const afterSubscribeCleanup = () => {
  const headerWrapper = document.querySelector('.js-header-menu') as HTMLFormElement
  const headerSummoner = document.querySelector('.js-menu-summonButton') as HTMLFormElement

  const ecoMailWrapperFooter = document.querySelector('.js-ecoMailSubsribe-footer-wrapper') as HTMLFormElement
  const ecoMailWrapperHeader = document.querySelector('.js-ecoMailSubsribe-header-wrapper') as HTMLFormElement

  const headerImageWrapper = document.querySelector('.js-header-imageWrapper') as HTMLFormElement

  const headerMessageContainer = document.querySelector('.js-header-imageWrapperNewsletterThankYou') as HTMLFormElement

  if (!headerWrapper.classList.contains('-isOpened')) {
    headerSummoner.click()
  }

  // ecoMailWrapperFooter.classList.add('-sent')
  ecoMailWrapperHeader.classList.add('-sent')
  headerImageWrapper.classList.add('-sent')

  headerMessageContainer.innerHTML = 'Nyní už jste s námi.<br>Co vás ještě zajímá?'

  setTimeout(() => {
    headerImageWrapper.classList.add('-stretched')
  }, 300)

  setTimeout(() => {
    ecoMailWrapperFooter.style.display = 'none'
  }, 1000)
}
